import { LocalStoreKeysEnum } from "../../../../../models/enums/localstore-keys.enum";
import http from "../../../../../services/http.service";

class Coupon {
  public validate = async (code: string) => {
    const price = localStorage.getItem(LocalStoreKeysEnum.LABEL_INSPECTION_PRICE);
    return http.post('v1/payment/coupon', { code, inspection_price: price })
      .then((result) => {
        const { data } = result;
        return Promise.resolve(data);
      })
      .catch((error) => {
        const { data } = error.response;
        return Promise.reject(data.errors);
      });
  }
}

export default new Coupon();
